<template>
  <div>
    <el-dialog title="联网搜图" :visible.sync="dialog" width="80%;" :lock-scroll="true" :append-to-body='true' :close-on-click-modal="false"
      @close="closeDialog(false)" center>
      <el-input placeholder="请输入内容" v-model="keyword" @change="souGouSearch" clearable class="input-with-select">
        <el-button slot="append" style="width: 200px;" icon="el-icon-search" @click="souGouSearch"></el-button>
      </el-input>
      <div style="padding: 10px 0;">
        <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 400px;">
          <div class="image-main">
            <div class="image-box" v-for="(item, index) in showList"
              :style="index === selectIndex ? 'box-shadow: 0px 0px 20px #ccc;' : ''" :key="index"
              @click="selectedBox(index)">
              <el-image error="onErrorImg(item,index)" style="width: 100px; height: 100px" :src="item.url"
                :preview-src-list="srcList">
              </el-image>
            </div>

          </div>
        </el-scrollbar>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[30, 60, 90]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="imageList.length">
        </el-pagination>
        <el-button size="small" @click="closeDialog(false)" style="margin-left: 20px;">取 消</el-button>
        <el-button size="small" type="primary" @click="closeDialog(true)">确 定</el-button>
      </div>

    </el-dialog>
  </div>

</template>
<script>
import { souGouSearch } from "@/api/basic.js";
export default {
  name: "dyh-dialog",
  props: ["title"],
  data() {
    return {
      dialog: false,
      keyword: "",
      imageList: [],
      currentPage: 1, //当前页
      pageSize: 30, //每页条数
      showList: [],
      srcList: [],
      selectIndex: -1, //选中的图片
      persent: {
        index: -1, //父组件选中的当索引
        key: ""
      },
      fullscreenLoading: false//加载状态
    }
  },
  methods: {
    closeDialog(key) {
      if (key === true) {
        //console.log("this.showList[this.selectIndex]", this.showList[this.selectIndex]);
        this.$emit("selectedImage", { ...this.showList[this.selectIndex], ...this.persent });
      }
      this.dialog = false;
    },
    selectedBox(index) {
      this.selectIndex = index;
    },
    /**
     * 失败的图片
     * @param item
     * @param {number} index 图片的索引
     */
    onErrorImg(item, index) { //调用image方法，删除失败的图片
      this.imageList.splice(index, 1);
    },
    /**
     * 显示图片选择窗口
     * @param {string} key 父组件传递过来的需要搜索的值
     */
    showDailog(key, item_name, index) {
      this.dialog = true;
      this.selectIndex = -1;
      this.persent = {
        index: index, //父组件选中的当索引
        key: key
      }
      if (item_name && item_name !== this.keyword) {
        this.keyword = item_name;
        this.souGouSearch();
      }
    },
    /**
     * 按照关键字从接口获取图片
     */
    async souGouSearch() {
      this.showList = [];
      const that = this;
      if (this.keyword.length > 0) {
        setTimeout(() => {
          that.fullscreenLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        }, 100)
        try {
          const imageList = await souGouSearch(this.keyword);
          if (imageList !== false) this.imageList = imageList;
          setTimeout(() => {
            this.fullscreenLoading.close();
          }, 5000);
          this.changeShowList();
        } catch (e) {
          this.fullscreenLoading.close();
        }
      } else {
        this.warnMessage("请输入内容后搜索");
      }
    },
    /**
     * 每页条数修改
     * @param {number} val 每页的条数
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.changeShowList();
    },
    /**
     * 当前页修改
     * @param {number} val 当前页
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.changeShowList();
    },
    /**
     * 设置当前页面显示的图片
     */
    changeShowList() {
      let list = [];
      let start = (this.currentPage - 1) * this.pageSize;
      let end = Number(this.pageSize) + Number(start) >= this.imageList.length ? this.imageList.length : Number(this.pageSize) + Number(start);
      for (let i = start; i < end; i++) {
        list.push(this.imageList[i]);
      }
      this.showList = list;
      //点击显示图片
      /* this.srcList = [];
      this.showList.forEach((item, index) => {
        this.srcList.push(item.url);
      }) */
      this.fullscreenLoading.close();
    }
  }
}

</script>
<style lang="less" scoped>
.image-box {
  width: 150px;
  height: 150px;
  margin: 15px;
  overflow: hidden;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

.image-box:hover {
  box-shadow: 0px 0px 20px #ccc;
}

.image-main {
  width: 100%;
  height: 100%;
  // background-color:chartreuse;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

/deep/.el-dialog {
  margin-top: 10vh !important;
  width: 1000px;
}

.dialog-footer {
  display: flex;
  justify-content: right;
  align-items: center;
  padding: 10px 20px;
}
</style>